<div class="submenu-complex-left">
    <nav class="nav overflow-y-hidden">
        <div class="d-flex flex-column gap-3 w-100 h-100">
            <div class="col-auto h-100 ms-3 mb-2">                                
                <list
                    id="program-list"
                    [clippedBody]="false"
                    [clippedSearch]="true"
                    allowMultiSelect="false"
                    [ngStyle]="{
                        opacity: data()?.isLoading() ? '0.4' : '',
                        pointerEvents: data()?.isLoading() ? 'none' : '',
                        cursor: data()?.isLoading() ? 'not-allowed' : ''
                    }"
                    (selectedEntity)="data().select($event)"
                    [entities]="data().items()"
                    [template]="programNodeTemplate"></list>
            </div>
        </div>
    </nav>
</div>

<ng-template
    #programNodeTemplate
    let-securableNode="item">
        <item-small-generic                 
        class="font-5 p-1 py-2 b-bottom"
        [ngClass]="{ 'text-faded': !securableNode['isHovering'] }"                                                                       
        (mouseenter)="securableNode['isHovering'] = true" 
        (mouseleave)="securableNode['isHovering'] = false"                                        
        isSelectable="true"
        [currentItem]="securableNode"
        [template]="programTemplate"/>
</ng-template>

<ng-template
    #programTemplate    
    let-securable="item">
        <presenter
            [data]="securable.value" /> 
</ng-template>
